"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _QueryTrace_wasForceClosed, _QueryTrace_fnClose, _QueryTrace_fnProgress, _Query_instances, _Query_tracing, _Query_leaveOpen, _Query_cancelAt, _Query_checkTrace, _Query_feed, _Query_log, _Query_onProgress, _Query_stopCheckTraces, _Query_checkTraces, _Query_canSendQuery, _Query_sendQueryInternal;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
const uuid_1 = require("uuid");
const debug_1 = __importDefault(require("debug"));
const shared_1 = require("@snort/shared");
const _1 = require(".");
const request_merger_1 = require("./request-merger");
const request_expander_1 = require("./request-expander");
/**
 * Tracing for relay query status
 */
class QueryTrace {
    constructor(relay, filters, connId, fnClose, fnProgress) {
        this.relay = relay;
        this.filters = filters;
        this.connId = connId;
        _QueryTrace_wasForceClosed.set(this, false);
        _QueryTrace_fnClose.set(this, void 0);
        _QueryTrace_fnProgress.set(this, void 0);
        this.id = (0, uuid_1.v4)();
        this.start = (0, shared_1.unixNowMs)();
        __classPrivateFieldSet(this, _QueryTrace_fnClose, fnClose, "f");
        __classPrivateFieldSet(this, _QueryTrace_fnProgress, fnProgress, "f");
        this.flatFilters = filters.flatMap(request_expander_1.expandFilter);
    }
    sentToRelay() {
        this.sent = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    gotEose() {
        this.eose = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    forceEose() {
        this.eose = (0, shared_1.unixNowMs)();
        __classPrivateFieldSet(this, _QueryTrace_wasForceClosed, true, "f");
        this.sendClose();
    }
    sendClose() {
        this.close = (0, shared_1.unixNowMs)();
        __classPrivateFieldGet(this, _QueryTrace_fnClose, "f").call(this, this.id);
        __classPrivateFieldGet(this, _QueryTrace_fnProgress, "f").call(this);
    }
    /**
     * Time spent in queue
     */
    get queued() {
        return (this.sent === undefined ? (0, shared_1.unixNowMs)() : __classPrivateFieldGet(this, _QueryTrace_wasForceClosed, "f") ? (0, shared_1.unwrap)(this.eose) : this.sent) - this.start;
    }
    /**
     * Total query runtime
     */
    get runtime() {
        return (this.eose === undefined ? (0, shared_1.unixNowMs)() : this.eose) - this.start;
    }
    /**
     * Total time spent waiting for relay to respond
     */
    get responseTime() {
        return this.finished ? (0, shared_1.unwrap)(this.eose) - (0, shared_1.unwrap)(this.sent) : 0;
    }
    /**
     * If tracing is finished, we got EOSE or timeout
     */
    get finished() {
        return this.eose !== undefined;
    }
}
_QueryTrace_wasForceClosed = new WeakMap(), _QueryTrace_fnClose = new WeakMap(), _QueryTrace_fnProgress = new WeakMap();
/**
 * Active or queued query on the system
 */
class Query {
    constructor(id, instance, feed, leaveOpen) {
        _Query_instances.add(this);
        /**
         * Which relays this query has already been executed on
         */
        _Query_tracing.set(this, []);
        /**
         * Leave the query open until its removed
         */
        _Query_leaveOpen.set(this, false);
        /**
         * Time when this query can be removed
         */
        _Query_cancelAt.set(this, void 0);
        /**
         * Timer used to track tracing status
         */
        _Query_checkTrace.set(this, void 0);
        /**
         * Feed object which collects events
         */
        _Query_feed.set(this, void 0);
        _Query_log.set(this, (0, debug_1.default)("Query"));
        this.id = id;
        __classPrivateFieldSet(this, _Query_feed, feed, "f");
        this.fromInstance = instance;
        __classPrivateFieldSet(this, _Query_leaveOpen, leaveOpen ?? false, "f");
        __classPrivateFieldGet(this, _Query_instances, "m", _Query_checkTraces).call(this);
    }
    isOpen() {
        return __classPrivateFieldGet(this, _Query_cancelAt, "f") === undefined && __classPrivateFieldGet(this, _Query_leaveOpen, "f");
    }
    canRemove() {
        return __classPrivateFieldGet(this, _Query_cancelAt, "f") !== undefined && __classPrivateFieldGet(this, _Query_cancelAt, "f") < (0, shared_1.unixNowMs)();
    }
    /**
     * Recompute the complete set of compressed filters from all query traces
     */
    get filters() {
        return (0, request_merger_1.flatMerge)(this.flatFilters);
    }
    get flatFilters() {
        return __classPrivateFieldGet(this, _Query_tracing, "f").flatMap(a => a.flatFilters);
    }
    get feed() {
        return __classPrivateFieldGet(this, _Query_feed, "f");
    }
    onEvent(sub, e) {
        for (const t of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            if (t.id === sub) {
                this.feed.add(e);
                break;
            }
        }
    }
    /**
     * This function should be called when this Query object and FeedStore is no longer needed
     */
    cancel() {
        __classPrivateFieldSet(this, _Query_cancelAt, (0, shared_1.unixNowMs)() + 5000, "f");
    }
    uncancel() {
        __classPrivateFieldSet(this, _Query_cancelAt, undefined, "f");
    }
    cleanup() {
        __classPrivateFieldGet(this, _Query_instances, "m", _Query_stopCheckTraces).call(this);
    }
    sendToRelay(c, subq) {
        if (!__classPrivateFieldGet(this, _Query_instances, "m", _Query_canSendQuery).call(this, c, subq)) {
            return;
        }
        return __classPrivateFieldGet(this, _Query_instances, "m", _Query_sendQueryInternal).call(this, c, subq);
    }
    connectionLost(id) {
        __classPrivateFieldGet(this, _Query_tracing, "f").filter(a => a.connId == id).forEach(a => a.forceEose());
    }
    connectionRestored(c) {
        if (this.isOpen()) {
            for (const qt of __classPrivateFieldGet(this, _Query_tracing, "f")) {
                if (qt.relay === c.Address) {
                    c.QueueReq(["REQ", qt.id, ...qt.filters], () => qt.sentToRelay());
                }
            }
        }
    }
    sendClose() {
        for (const qt of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            qt.sendClose();
        }
        this.cleanup();
    }
    eose(sub, conn) {
        const qt = __classPrivateFieldGet(this, _Query_tracing, "f").find(a => a.id === sub && a.connId === conn.Id);
        qt?.gotEose();
        if (!__classPrivateFieldGet(this, _Query_leaveOpen, "f")) {
            qt?.sendClose();
        }
    }
    /**
     * Get the progress to EOSE, can be used to determine when we should load more content
     */
    get progress() {
        const thisProgress = __classPrivateFieldGet(this, _Query_tracing, "f").reduce((acc, v) => (acc += v.finished ? 1 : 0), 0) / __classPrivateFieldGet(this, _Query_tracing, "f").length;
        if (isNaN(thisProgress)) {
            return 0;
        }
        return thisProgress;
    }
}
exports.Query = Query;
_Query_tracing = new WeakMap(), _Query_leaveOpen = new WeakMap(), _Query_cancelAt = new WeakMap(), _Query_checkTrace = new WeakMap(), _Query_feed = new WeakMap(), _Query_log = new WeakMap(), _Query_instances = new WeakSet(), _Query_onProgress = function _Query_onProgress() {
    const isFinished = this.progress === 1;
    if (this.feed.loading !== isFinished) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "%s loading=%s, progress=%d, traces=%O", this.id, this.feed.loading, this.progress, __classPrivateFieldGet(this, _Query_tracing, "f"));
        this.feed.loading = isFinished;
    }
}, _Query_stopCheckTraces = function _Query_stopCheckTraces() {
    if (__classPrivateFieldGet(this, _Query_checkTrace, "f")) {
        clearInterval(__classPrivateFieldGet(this, _Query_checkTrace, "f"));
    }
}, _Query_checkTraces = function _Query_checkTraces() {
    __classPrivateFieldGet(this, _Query_instances, "m", _Query_stopCheckTraces).call(this);
    __classPrivateFieldSet(this, _Query_checkTrace, setInterval(() => {
        for (const v of __classPrivateFieldGet(this, _Query_tracing, "f")) {
            if (v.runtime > 5000 && !v.finished) {
                v.forceEose();
            }
        }
    }, 500), "f");
}, _Query_canSendQuery = function _Query_canSendQuery(c, q) {
    if (q.relay && q.relay !== c.Address) {
        return false;
    }
    if (!q.relay && c.Ephemeral) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "Cant send non-specific REQ to ephemeral connection %O %O %O", q, q.relay, c);
        return false;
    }
    if (q.filters.some(a => a.search) && !c.SupportsNip(_1.Nips.Search)) {
        __classPrivateFieldGet(this, _Query_log, "f").call(this, "Cant send REQ to non-search relay", c.Address);
        return false;
    }
    return true;
}, _Query_sendQueryInternal = function _Query_sendQueryInternal(c, q) {
    const qt = new QueryTrace(c.Address, q.filters, c.Id, x => c.CloseReq(x), () => __classPrivateFieldGet(this, _Query_instances, "m", _Query_onProgress).call(this));
    __classPrivateFieldGet(this, _Query_tracing, "f").push(qt);
    c.QueueReq(["REQ", qt.id, ...qt.filters], () => qt.sentToRelay());
    return qt;
};
//# sourceMappingURL=data:application/json;base64,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